export default __webpack_public_path__ + "static/media/react-logo.9e86210e.svg";